import { useQuery } from '@tanstack/react-query';
import { getFreeTrialStatus } from '../../services/subscriptions';
import { useTokens } from '../auth/useTokens';

const useFreeTrialStatus = () => {
  const authDetails = useTokens.getState();
  return useQuery({
    queryKey: ['free-trial-status'],
    queryFn: () =>
      getFreeTrialStatus({
        userIdBw: authDetails.userInfo.username,
        clientId: authDetails.userInfo.broker,
      }),
  });
};

export default useFreeTrialStatus;
